import axios from 'axios';
import AppModel from 'Models/AppModel';

const { API_URI } = AppModel;

class ResourceController {
  static getResources(resource, filters = null) {
    return axios.get(`${API_URI}/${resource}`, {
      params: filters,
    });
  }

  static getResource(resource, id) {
    return axios.get(`${API_URI}/${resource}/${id}`);
  }

  static storeResource(resource, data) {
    return axios.post(`${API_URI}/${resource}`, data);
  }

  static updateResource(resource, id, data) {
    return axios.patch(`${API_URI}/${resource}/${id}`, data);
  }

  static destroyResource(resource, id) {
    return axios.delete(`${API_URI}/${resource}/${id}`);
  }

  static restoreResource(resource, id) {
    return axios.post(`${API_URI}/${resource}/${id}/restore`);
  }
}

export default ResourceController;
